var Component = require("!../../../../../campaigns/indiancreek/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../campaigns/indiancreek/node_modules/vue-loader/lib/selector?type=script&index=0!./campaign-configuration.vue"),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// /var/www/apps.frsfulfillment.com/resources/assets/js/components/frontend/mixin/campaign-configuration.vue
// module id = 9Esz
// module chunks = 1